import ProductDetailExpand from "@scenes/pdp/utils/ProductDetailExpand";
import styled from "styled-components/native";
import { MatchProductDetailViewProps } from "./types";
import { Platform } from "react-native";
import { css } from "styled-components/native";
import { matchPairConatinerWidth } from "@scenes/findMatch/utils";
import { useFindMatch } from "@scenes/findMatch/FindMatchContext";

const MatchProductDetailView = ({
  itemDetail,
  otherDetail,
  currentIndex,
  productColor,
}: MatchProductDetailViewProps) => {
  const { productType, t } = useFindMatch();
  return (
    <PriceDetailContainer>
      <FlexMainView>
        <MainContainerView testID="findMatch.productDetail.primary">
          <LeftLabelContainer keyMargin={20}>
            <ProductDetailExpand
              itemDetail={itemDetail}
              isProductDetail={true}
              title={t("productDetailPage.productDetails.text")}
              productColor={productColor}
              isFindAMatch={true}
              productType={productType}
            />
          </LeftLabelContainer>
        </MainContainerView>
        <GapView />
        <MainContainerView testID="findMatch.productDetail.secondary">
          <LeftLabelContainer keyMargin={20}>
            <ProductDetailExpand
              itemDetail={otherDetail?.[currentIndex]}
              isProductDetail={true}
              title={t("productDetailPage.productDetails.text")}
              productColor={productColor}
              isFindAMatch={true}
              productType={productType}
            />
          </LeftLabelContainer>
        </MainContainerView>
      </FlexMainView>
    </PriceDetailContainer>
  );
};

const PriceDetailContainer = styled.View`
  flex-direction: column;
`;

const MainContainerView = styled.View<any>`
  flex-direction: column;
  flex: 1;
  ${({ theme }) => matchPairConatinerWidth(theme)}
`;

const FlexMainView = styled.View<any>`
  flex-direction: row;
`;

const LeftLabelContainer = styled.View<any>`
  margin: ${({ keyMargin }) => `10px ${keyMargin}px`};
`;

const GapView = styled.View`
  ${({ theme }) =>
    Platform.OS === "web" &&
    !theme.isMobile &&
    css`
      width: 30px;
    `}
`;

export default MatchProductDetailView;
